<template>
  <div>
    <div>
      <vx-card v-show="isCardActiveLocal" class="mt-3">
        <div v-if="quizType == 'graded'" class="vx-row">
          <div class="flex flex-wrap items-center justify-center">
            <p class="ml-4 mr-2">Assessor Score: </p>
            <p><strong>{{ question.assessment.awardedPoints + " " + "/" + " " + question.assessment.maxPoints }}</strong></p>
          </div>
        </div>
        <div class="mt-2 vx-row">
          <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <label>Last Comment by {{question.assessment.lastCommentBy}}:</label>
            <vs-textarea readOnly v-model="question.assessment.lastComment" />
          </div>
          <div v-if="question.assessment.lastComment" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <div style="padding-top: 20px;">
              <vs-button color="success" class="mr-3 vs-con-loading__container" ref="viewHistoryButton" @click.stop.prevent="showCommentHistoryPopup(question.assessment.assessmentId)">View History</vs-button>
            </div>
          </div>
          </div>
          <div class="mt-2 vx-row">
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
              <label>Comment:</label>
              <vs-textarea v-model="question.assessment.moderatorComment" />
            </div>
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
              <label>Predefined Comments:</label>
              <v-select placeholder="Search / Select Predefined Comment" :options="predefinedComments" v-model="predCommentDropdown" @search:blur="addComment"></v-select>
            </div>
          </div>
      </vx-card>
    </div>

    <!-- Comments Popup -->
    <div>
      <vs-popup class="commentPopup" id="commentHistory" ref="commentHistoryPopup" title="Comment History" :active.sync="commentHistoryPopupActive">
        <div v-if="comments.length > 0">
          <table id="commentTable" style="width: 100%;" stripe>
            <thead>
              <tr>
                <th>Comment</th>
                <th>Created By</th>
                <th>Created On</th>
              </tr>
            </thead>
            <tbody>
              <tr class="ml-0" v-for="(item, index) in comments" :key="index">
                <td>
                  {{ item.comment }}
                </td>
                <td class="nowrap">
                  {{ item.commentType  }} ({{item.createdBy}})
                </td>
                <td class="nowrap">
                  {{ item.createdOn.replace("T", " ").split('.')[0] }}
                </td>
              </tr>

            </tbody>
          </table>
        </div>
        <div v-else>
          <p style="text-align-last: center;">No comments yet...</p>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      },
      quizType: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        predCommentDropdown: 0,
        commentHistoryPopupActive: false,
        comments: []
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {

          }
        }
      },
    },
    watch: {
      isCardActive: function (val) {
        if (val) {
          var self = this;
        }
      },
    },
    methods: {
      addComment() {
        var self = this;
        if (self.predCommentDropdown) {
          if (self.question.assessment.moderatorComment == null) {
            self.question.assessment.moderatorComment = "";
          }
          self.question.assessment.moderatorComment += self.predCommentDropdown.label + " ";
        }
      },
      showCommentHistoryPopup(assessmentId) {
        var self = this;
        self.comments = [];

        var onSuccess = function (response) {
          self.comments = response.data;


          self.commentHistoryPopupActive = true;
        };

        var onFinally = function () {

        };

        self.$ajaxGet(self, "ISpringQuizAssessment/GetCommentsByAssessmentId?id=" + assessmentId, onSuccess, onFinally);
      }
    },
    mounted() {

    },
  }

</script>

<style lang="scss">
  #commentHistory .vs-popup {
    min-width: 600px;
    width: auto !important;
    max-width: 65%;
  }

  #commentTable .nowrap {
    white-space: nowrap !important;
    padding-left: 10px;
    padding-right: 10px;
    text-align: left;
  }
</style>
